<tcm-main-frame [isLoading]="isLoading" titleKey="Screens.FittingReport.Details.Title">
  <ng-container commands>
    <button actionButton #saveBtn templateType="SaveExit" class="me-2" (click)="save()"></button>
    <button class="btn btn-default me-4"
            (click)="back()">{{'Common.SearchActionsAndDetailsActions.Cancel' | translate}}</button>
  </ng-container>
  <ng-container body>
    <tcm-details-layout>
      <div form-area>
        <form #reportForm [class.readonly]="!canEdit">
          <div class="tcm-details-panel">
            <div class="wrapper" [innerHTML]="content">
            </div>
          </div>
        </form>
      </div>
    </tcm-details-layout>
  </ng-container>
</tcm-main-frame>
